<template>
  <div class="payment">
    <payment-loading-view />
    <div class="left">
      <div class="top">
        <subscription-type-view />
      </div>
      <div class="bottom">
        <address-view />
      </div>
    </div>
    <div class="right">
      <div class="top">
        <logo-view />
      </div>
      <div class="middle">
        <hint-view v-if="customerCountry == null" />
        <vat-view
          v-if="
            this.$store.state.customerData.customerType == 2 &&
            customerCountryInsideEu &&
            this.getCountryWithId(this.$store.state.customerData.country).id !=
              57
          "
        />
      </div>
      <div class="bottom">
        <payment-method-view
          v-if="
            vatValidToSubmit &&
            subscriptionTypeLoaded &&
            customerCountry != null
          "
        />
      </div>
      <span
        v-if="
          vatValidToSubmit &&
          subscriptionTypeLoaded &&
          customerCountry != null
        "
        >Payments by adyen. Please read the <a target="_blank" href="https://www.adyen.com/legal/terms-and-conditions">terms and conditions</a> from adyen.</span
      >
    </div>
  </div>
</template>

<script>
import SubscriptionTypeView from "@/components/Checkout/SubscriptionType.vue";
import AddressView from "@/components/Checkout/Address.vue";
import HintView from "@/components/Checkout/Hint.vue";
import LogoView from "@/components/Checkout/Logo.vue";
import VatView from "@/components/Checkout/Vat.vue";
import PaymentMethodView from "@/components/Checkout/PaymentMethod.vue";
import PaymentLoadingView from "@/components/Checkout/PaymentLoading.vue";

export default {
  name: "payment-view",
  props: {
    title: String,
  },
  components: {
    "subscription-type-view": SubscriptionTypeView,
    "address-view": AddressView,
    "logo-view": LogoView,
    "hint-view": HintView,
    "vat-view": VatView,
    "payment-method-view": PaymentMethodView,
    "payment-loading-view": PaymentLoadingView,
  },
  computed: {
    vatValidToSubmit() {
      if (
        this.$store.state.vatCheckSuccessfull ||
        !(this.customerCountryInsideEu && this.getCountryWithId(this.$store.state.customerData.country).id != 57) ||
        this.$store.state.customerData.customerType == 1
      ) {
        return true;
      }
      return false;
    },
    subscriptionTypeLoaded() {
      return this.$store.state.subscriptionTypeLoaded;
    },
    customerCountry() {
      return this.$store.state.customerData.country;
    },
    customerCountryInsideEu() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.payment {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}
.left {
  width: 50%;
  height: 100%;
  display: flex;
  border-right: 1px solid #c7c9c8;
  flex-direction: column;
  padding-right: 60px;
}
.left .top {
  display: flex;
  width: 100%;
  height: 35%;
}
.left .bottom {
  display: flex;
  width: 100%;
  height: 65%;
}

.right {
  width: 50%;
  height: 100%;
  display: flex;
  border-left: 1px solid #c7c9c8;
  flex-direction: column;
  padding-left: 60px;
}
.right .top {
  display: flex;
  width: 100%;
  height: 12%;
}
.right .middle {
  display: flex;
  width: 100%;
  height: 19%;
}
.right .bottom {
  display: flex;
  width: 100%;
  height: 65%;
}

@media screen and (max-width: 1420px) {
  .payment {
    flex-direction: column;
  }
  .left {
    margin-bottom: 40px;
  }
  .left,
  .right {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    height: 730px;
    border: none;
  }
}
</style>
